/* eslint-disable func-names */
import React, { useState } from 'react';
import {
  FasEnvelope, FasPhone, FasFax, FasComment
} from 'assets/icons';
import { getUIDTFormat, dateFormatter } from 'helpers';
import { ATCONSTANTS as ATC } from 'appconstants';

const DATE_FORMAT = 'dd-MMM-yyyy';
const TIME_FORMAT = 'hh:mm:ss a';

function CommentDetail(props) {
  const { comment } = props;
  const { createdDate, comments, createdBy } = comment;

  const getIconType = ({ commentMethod, id }) => {
    switch (commentMethod) {
      case 'EMAIL':
        return <FasEnvelope data-id={id} className="color-dark-blue" title="Email type" />;
      case 'FAX':
        return <FasFax className="color-dark-blue" title="Fax type" />;
      case 'PHONE':
        return <FasPhone className="color-dark-blue" title="Phone type" />;
      default:
        return <FasComment className="color-dark-blue" title="Comment" />;
    }
  };

  let d = '';
  if (createdDate != null) {
    d = `${dateFormatter(createdDate, DATE_FORMAT)} at ${dateFormatter(createdDate, TIME_FORMAT)}`;
  }
  const header = `${d} by ${createdBy}`;
  return (
    <div className="p-3 mt-1 mb-4 rounded shadow-sm">
      <div className="mb-2">
        <span className="mr-2">{getIconType(comment)}</span>
        <span className="color-dark-blue font-bold">{header}</span>
      </div>
      <p>{comments}</p>
    </div>
  );
}

function CommentsSection({ comments, commentsSorted }) {
  const [showRecentComment, setShowRecentComment] = useState(false);
  const onClickSort = () => setShowRecentComment(!showRecentComment);
  const showComments = showRecentComment ? commentsSorted : comments;
  return (
    <div className="mt-2" style={{ height: '100%' }}>
      {showComments.length > 1 ? (
        <div className="align-right text-right p-3">
          Sort:
          <button
            data-id={`${ATC.PACKETID}COMMENT_SORT${ATC.BUTTON}`}
            className="fn-btn mx-1"
            onClick={onClickSort}
            type="button"
          >
            {showRecentComment ? 'Oldest first' : 'Newest first'}
          </button>
        </div>
      ) : (
        <div className="clear-both" />
      )}
      <div className="pt-1 px-3 pb-4" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        {showComments.map((c) => (
          <CommentDetail key={c.id} comment={c} />
        ))}
      </div>
    </div>
  );
}

function SubHeader({ title }) {
  return <div className="float-left ml-3 color-dark-blue font-bold font-lg mt-4">{title}</div>;
}

export default function CommentsNarrative({ packetComments }) {
  const internalComments = [];
  const externalComments = [];
  const internalCommentsSorted = [];
  const externalCommentsSorted = [];

  packetComments
    .sort((a, b) => getUIDTFormat(a.createdDate) - getUIDTFormat(b.createdDate))
    .forEach((comment) => {
      const { commentType } = comment;
      if (commentType === 'I') {
        internalComments.push(comment);
      } else {
        externalComments.push(comment);
      }
    });

  packetComments.reverse().forEach((comment) => {
    const { commentType } = comment;
    if (commentType === 'I') {
      internalCommentsSorted.push(comment);
    } else {
      externalCommentsSorted.push(comment);
    }
  });

  return (
    <div className="row mb-3">
      <div className="col-6 mr-4">
        <SubHeader title="Internal Comments" />
        {internalComments.length > 0 ? (
          <CommentsSection
            comments={internalComments}
            commentsSorted={internalCommentsSorted}
            key="internal-comments"
          />
        ) : (
          <div className="mt-2" style={{ height: '100%' }} />
        )}
      </div>
      <div className="col-6">
        <SubHeader title="External Comments" />
        {externalComments.length > 0 ? (
          <CommentsSection
            comments={externalComments}
            commentsSorted={externalCommentsSorted}
            key="external-comments"
          />
        ) : (
          <div className="mt-2" style={{ height: '100%' }} />
        )}
      </div>
    </div>
  );
}
